import React, { Fragment, PureComponent } from 'react';
import ProgressGraph from './progress-graph';
import RemarkTimeline from './remark-timeline';
import AnalysisChart from './analysis-chart';

import { Menu } from 'semantic-ui-react';

const tabOptions = [
  {
    id: 'analysis',
    label: 'Analysis',
  },
  {
    id: 'progress',
    label: 'Progress',
  },
  {
    id: 'remarks',
    label: 'Remarks',
  },
];

export default class TabComponentSemantic extends PureComponent {
  constructor() {
    super();
    this.state = {
      activeTabId: 'analysis',
    };
  }

  getComponent = () => {
    const { data } = this.props;
    const { activeTabId } = this.state;
    if (activeTabId === 'progress') {
      return <ProgressGraph programCode={data._id.program} data={data.progress} />;
    } else if (activeTabId === 'remarks') {
      let studentFeedback = {};
      Object.entries(data.rating_objs).forEach(([obj_id, obj]) => {
        let feedbackObj = JSON.parse(obj.meta);
        if (feedbackObj.feedback) {
          studentFeedback[obj_id] = {
            feedback: feedbackObj.feedback,
            created_on: obj.created_on,
            rating: obj.rating,
          };
        }
      });
      return (
        <RemarkTimeline
          examDetails={data.exam_details}
          teacherRemarks={data.teacher_remarks}
          studentFeedback={studentFeedback}
        />
      );
    } else if (activeTabId === 'analysis') {
      return <AnalysisChart data={data} />;
    }
  };

  handleItemClick = (e, { name }) => {
    this.setState({
      activeTabId: name,
    });
  };

  render() {
    const { activeTabId } = this.state;
    return (
      <Fragment>
        <Menu pointing secondary>
          {tabOptions.map(({ id, label }) => (
            <Menu.Item
              name={id}
              active={activeTabId === id}
              onClick={this.handleItemClick}
            >
              {label}
            </Menu.Item>
          ))}
        </Menu>
        {this.getComponent()}
      </Fragment>
    );
  }
}
